import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	play: {
		id: 'app.program.playButton.play',
		defaultMessage: 'Play',
		description: 'Primary button on a program page that starts the program',
	},
	playNext: {
		id: 'app.program.playButton.playNext',
		defaultMessage: 'Play Next',
		description:
			'Primary button on a program page once the member has progress, resuming at the next session',
	},
	pause: {
		id: 'app.program.playButton.pause',
		defaultMessage: 'Pause',
		description: 'Primary button on a program page while one of its sessions is playing',
	},
});
